import React from 'react';
import {
  FaTachometerAlt,
  FaFileUpload,
  FaBuilding,
  FaUsers,
  FaCog,
  FaChevronLeft,
  FaChevronRight,
  FaTimes,
  FaBars,
  FaCrown
} from 'react-icons/fa';

const SuperAdminSidebar = ({ 
  sidebarOpen, 
  setSidebarOpen, 
  activeSection, 
  setActiveSection, 
  userInfo,
  fullscreenMode
}) => {

  const sidebarItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <FaTachometerAlt /> },
    { id: 'extractions', label: 'Extractions', icon: <FaFileUpload /> },
    { id: 'companies', label: 'Companies', icon: <FaBuilding /> },
    { id: 'users', label: 'Users', icon: <FaUsers /> },
    { id: 'settings', label: 'Settings', icon: <FaCog /> },
  ];

  // Don't render sidebar in fullscreen mode
  if (fullscreenMode) {
    return null;
  }

  return (
    <>
      {/* Sidebar Container */}
      <div
        className={`fixed inset-y-0 left-0 z-40 pt-16 h-screen bg-white dark:bg-gray-900 border-r border-gray-200 dark:border-gray-800 transition-all duration-300 ease-in-out
        ${sidebarOpen ? 'w-64' : 'w-16'}
        ${sidebarOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}
      >

        {/* Sidebar Header */}
        <div className="flex items-center justify-between h-16 px-4 border-b border-gray-200 dark:border-gray-800 bg-gradient-to-r from-blue-50 to-purple-50 dark:from-gray-900 dark:to-gray-900">
          {sidebarOpen ? (
            <div className="flex items-center">
              <FaCrown className="h-7 w-7 text-purple-600 dark:text-purple-400" />
              <span className="ml-3 text-lg font-bold text-gray-900 dark:text-white">
                SUPER ADMIN
              </span>
            </div>
          ) : (
            <FaCrown className="h-7 w-7 text-purple-600 dark:text-purple-400 mx-auto" />
          )}

          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="hidden lg:flex p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors"
          >
            {sidebarOpen ? <FaChevronLeft /> : <FaChevronRight />}
          </button>

          <button
            onClick={() => setSidebarOpen(!sidebarOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-600 dark:text-gray-400 transition-colors"
          >
            {sidebarOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Sidebar Menu */}
        <nav className="p-4 space-y-1 overflow-y-auto h-[calc(100vh-8rem)] bg-white dark:bg-gray-900">
          {sidebarItems.map((item) => (
            <button
              key={item.id}
              onClick={() => setActiveSection(item.id)}
              className={`flex items-center w-full px-4 py-3 rounded-lg transition-all duration-200 text-base font-medium group
                ${
                  activeSection === item.id
                    ? 'bg-gradient-to-r from-purple-600 to-blue-600 text-white shadow-lg shadow-purple-200 dark:shadow-purple-900/30'
                    : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-gray-900 dark:hover:text-white hover:shadow-md'
                }`}
            >
              <span className={`text-xl transition-transform ${activeSection === item.id ? 'scale-110' : 'group-hover:scale-110'}`}>
                {item.icon}
              </span>

              {sidebarOpen && (
                <span className="ml-4 truncate font-medium">
                  {item.label}
                </span>
              )}
              
              {/* Active indicator dot */}
              {activeSection === item.id && !sidebarOpen && (
                <div className="absolute right-2 w-2 h-2 bg-white rounded-full"></div>
              )}
            </button>
          ))}
        </nav>

        {/* User Profile */}
        <div
          className={`absolute bottom-0 left-0 right-0 p-4 border-t border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900
          ${sidebarOpen ? 'flex items-center gap-3' : 'flex justify-center'}`}
        >
          <div className={`flex items-center justify-center ${sidebarOpen ? 'w-10 h-10' : 'w-12 h-12'} rounded-full bg-gradient-to-r from-purple-600 to-blue-600 shadow-md hover:shadow-lg transition-shadow`}>
            <FaCrown className={`${sidebarOpen ? 'text-sm' : 'text-lg'} text-white`} />
          </div>

          {sidebarOpen && (
            <div className="min-w-0 flex-1">
              <p className="text-sm font-semibold text-gray-900 dark:text-white truncate">
                {userInfo?.name || 'Super Admin'}
              </p>
              <p className="text-xs text-gray-500 dark:text-gray-400 truncate">
                System Administrator
              </p>
              <div className="mt-1">
                <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gradient-to-r from-purple-100 to-blue-100 text-purple-800 dark:from-purple-900/30 dark:to-blue-900/30 dark:text-purple-300">
                  Super Admin
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SuperAdminSidebar;